import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { KrsEntry } from '../models/krs-entry/krs-entry.model';

@Injectable({
  providedIn: 'root',
})
export class KrsEntryService {
  private _krsEntry$ = new BehaviorSubject<KrsEntry>(null);

  get krsEntry$(): Observable<KrsEntry> {
    return this._krsEntry$.asObservable();
  }

  setKrsEntry(krsEntry: KrsEntry) {
    this._krsEntry$.next(krsEntry);
  }

  getKrsEntry(): KrsEntry | null {
    return this._krsEntry$.value;
  }

  public normalizeKRS(controlValue: string): string {
    return controlValue !== undefined &&
      controlValue !== null &&
      !isNaN(Number(controlValue)) &&
      controlValue.length > 0
      ? controlValue.padStart(10, '0')
      : null;
  }

  jestWykreslonyZKrs(krsEntry: KrsEntry): boolean {
    return krsEntry?.naglowekA?.wykreslony;
  }
}
